import { render, staticRenderFns } from "./CompGeneralDropdown.vue?vue&type=template&id=81b87b9a"
import script from "./CompGeneralDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralDropdown.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports